import {Injectable} from '@angular/core';
import {AuthService} from '../../../shared/services/auth/auth.service';
import {SettingsService} from './settings.crud.service';
import {SettingsEnum} from '../enum/settings-type.enum';
import {Observable} from 'rxjs';

const defaultSystemParameters = {
  color: [
    SettingsEnum.themeVersion,
    SettingsEnum.primary,
    SettingsEnum.navheaderBg,
    SettingsEnum.headerBg,
    SettingsEnum.sidebarBg,
  ],
  placed: [
    SettingsEnum.layout,
    SettingsEnum.sidebarPosition,
    SettingsEnum.sidebarStyle,
    SettingsEnum.headerPosition,
  ],
};

export const defaultStyles = [
  {
    key: SettingsEnum.themeVersion,
    value: 'light',
  },
  {
    key: SettingsEnum.layout,
    value: 'vertical',
  },
  {
    key: SettingsEnum.sidebarPosition,
    value: 'fixed',
  },
  {
    key: SettingsEnum.sidebarStyle,
    value: 'full',
  },
  {
    key: SettingsEnum.headerPosition,
    value: 'fixed',
  },
  {
    key: SettingsEnum.primary,
    value: 'color_1',
  },
  {
    key: SettingsEnum.navheaderBg,
    value: 'color_4',
  },
  {
    key: SettingsEnum.headerBg,
    value: 'color_4',
  },
  {
    key: SettingsEnum.sidebarBg,
    value: 'color_1',
  },
];

@Injectable({
  providedIn: 'root',
})
export class ThemeSettingsService {
  constructor(
    private readonly authService: AuthService,
    private readonly settingsService: SettingsService
  ) {
  }

  // Stilleri body e ekle
  setToBody(settings: any[]) {
    for(const setting of settings){
      const prop = 'data-' + setting.key;
        document.body.setAttribute(prop, setting.value);
    }
      const theme = settings?.find((s: any) => s.key === SettingsEnum.themeVersion)?.value ?? 'light'
      this.setTheme(theme)
  }

  // LocalStorage dan ayarları alıp set et
  loadSettingsFromStorage() {
    const styles = JSON.parse(localStorage.getItem('core-settings') || '[]');
    return styles;
  }

  // LocalStoraga  ayarları kaydet
  saveSettingsToStorage(settings: any[]) {
    const storageData: any[] = JSON.parse(
      localStorage.getItem('core-settings') || '[]'
    );

     const storageMap = new Map(
      storageData.map(item => [item.key, item.value])
    );

     settings.forEach(s => {
      storageMap.set(s.key, s.value);
    });

     const mergedData = Array.from(storageMap.entries()).map(
      ([key, value]) => ({ key, value })
    );

    localStorage.setItem('core-settings', JSON.stringify(mergedData));

  }

  // userId ye göre thema set et
  setUserThemeSettings() {
    const userId = this.authService.getUserId();
    // user thema arrayini al key value seklinde saveStorage kayıt et sonra bodye setle
    if (userId) {
      this.settingsService.getUserSettings({}, this.authService.isSuperAdmin()).subscribe({
        next: (res) => {
          let data = res?.length > 0 ? res : defaultStyles;
         const findedTheme=data.find(d=>d.key===SettingsEnum.themeVersion);
          if(!findedTheme){
            data.push({key:SettingsEnum.themeVersion,value:'light'})
          }

          this.saveSettingsToStorage(data);
          this.setToBody(data);
        },
        complete: () => {
          const storage = this.loadSettingsFromStorage();
          const theme = storage?.find((s: any) => s.key === SettingsEnum.themeVersion)?.value ?? 'light'
          this.setTheme(theme)
        },
      });
    }
  }

  setThemeDefaultSettings(tab: 'color' | 'placed'): Observable<any[]> {
    return new Observable((observer) => {
      // Önce adminlerden settingsi al
      this.settingsService.getUserSettings({}, this.authService.isSuperAdmin()).subscribe({
        next: (res) => {

          // Var olan settingsleri storage'dan getir
          const beforedData = this.loadSettingsFromStorage();
          // Eğer adminden data geldiyse onu kabul et, yoksa defaultStyles'dan doldur
          const data = res?.length > 0 ? res : defaultStyles;

          // Hangi tabta basılmış ise o tabın keylerini içeren arrayi al
          const defaultParams = defaultSystemParameters[tab];

          for (const key of defaultParams) {
            // Daha önce bu key var mı yok mu onu bul
            const existingSetting = beforedData.find((item:any) => item.key === key);
            const newValue = data.find(item => item.key === key)?.value;

            if (existingSetting) {
              // Eğer key var ise değerini datadan gelen value’ya eşitle (yoksa mevcut değer korunur)
              if (newValue !== undefined) {
                existingSetting.value = newValue;
              }
            } else {
              // Eğer key yok ise yeni objeyi pushla
              beforedData.push({ key, value: newValue });
            }
          }

          // Oluşan yeni key-value yapısını yeniden kaydederek güncelle
          this.saveSettingsToStorage(beforedData);

          // Sonra body'e uygula
          // this.setToBody(beforedData);

          // İşlem başarılı, sonucu döndür
          observer.next(beforedData);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }


  setTheme(mode: 'dark' | 'light'): void {
    const theme = mode === 'dark' ? 'vela-blue' : 'aura-light-blue';
    const themeLink = document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = `assets/themes/${theme}/theme.css`;
    }
  }
}
